import React from 'react';
//import './Heading.scss'; 

const Paragraph = ({ className, children, id }) => {
  return <p className={className} id={id}>{children}</p>;
};

export default Paragraph;
